import { Panel, PanelGroup } from "react-resizable-panels";
import { SimpleEditorLoadingSkeleton } from "src/tiptap/components/tiptap-templates/simple/simple-editor-loading-skeleton";

type TiptapEditorLoadingSkeletonProps = {
  documentId?: string;
};

export const TiptapEditorLoadingSkeleton = ({
  documentId,
}: TiptapEditorLoadingSkeletonProps) => (
  <PanelGroup direction="horizontal" className="flex flex-1 min-h-0 w-full">
    <Panel
      id="tiptap-doc-viewer-main"
      order={0}
      defaultSize={100}
      minSize={50}
      className="min-w-0"
    >
      <div className="tiptap-editor-page relative flex h-full min-h-0 flex-1 flex-col overflow-hidden">
        <div className="min-h-0 flex-1 overflow-hidden">
          <div className="simple-editor-wrapper">
            <div className="simple-editor-workspace" aria-busy="true">
              <SimpleEditorLoadingSkeleton
                label={`Loading ${documentId || "document"}`}
              />
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </PanelGroup>
);
